var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatabase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9497 8.33325C35.9497 11.0947 29.234 13.3333 20.9497 13.3333C12.6654 13.3333 5.94971 11.0947 5.94971 8.33325M35.9497 8.33325C35.9497 5.57183 29.234 3.33325 20.9497 3.33325C12.6654 3.33325 5.94971 5.57183 5.94971 8.33325M35.9497 8.33325V31.6666C35.9497 34.4333 29.283 36.6666 20.9497 36.6666C12.6164 36.6666 5.94971 34.4333 5.94971 31.6666V8.33325M35.9497 16.2003C35.9497 18.9669 29.283 21.2003 20.9497 21.2003C12.6164 21.2003 5.94971 18.9669 5.94971 16.2003M35.9497 24.0666C35.9497 26.8333 29.283 29.0666 20.9497 29.0666C12.6164 29.0666 5.94971 26.8333 5.94971 24.0666",
    stroke: "#278DEC",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.cf159e71f9ee24a57bb8eb6f4770043c.svg";
export { ForwardRef as ReactComponent };